import { apiRequest, DASHBOARD_ENDPOINTS, ADMIN_ENDPOINTS } from '../config/api';

/**
 * Dashboard Service
 * Handles all dashboard-related API calls for both user and admin dashboards
 */

class DashboardService {

  // =============================================================================
  // USER DASHBOARD METHODS
  // =============================================================================

  /**
   * Get user dashboard statistics
   * @param {string} period - Time period (7d, 30d, 90d, 180d, 1y, all)
   */
  async getUserDashboardStats(period = '30d') {
    try {
      const queryParams = period ? `?period=${period}` : '';
      const endpoint = `${DASHBOARD_ENDPOINTS.STATS}${queryParams}`;
      const response = await apiRequest(endpoint, {
        method: 'GET'
      });
      return response;
    } catch (error) {
      console.error('Error fetching user dashboard stats:', error);
      throw error;
    }
  }

  /**
   * Get user activity history
   */
  async getUserActivity() {
    try {
      const response = await apiRequest(DASHBOARD_ENDPOINTS.RECENT_ACTIVITY, {
        method: 'GET'
      });
      return response;
    } catch (error) {
      console.error('Error fetching user activity:', error);
      throw error;
    }
  }

  // =============================================================================
  // ADMIN DASHBOARD METHODS
  // =============================================================================

  /**
   * Get admin dashboard statistics
   * @param {string} period - Time period (7d, 30d, 90d, 180d, 1y, all)
   */
  async getAdminDashboardStats(period = '30d') {
    try {
      const queryParams = period ? `?period=${period}` : '';
      const endpoint = `${ADMIN_ENDPOINTS.SYSTEM_STATS}${queryParams}`;
      const response = await apiRequest(endpoint, {
        method: 'GET'
      });
      return response;
    } catch (error) {
      console.error('Error fetching admin dashboard stats:', error);
      throw error;
    }
  }

  /**
   * Get admin analytics
   * @param {number} days - Number of days for analytics (default: 30)
   */
  async getAdminAnalytics(days = 30) {
    try {
      const response = await apiRequest(`/api/admin/analytics/?days=${days}`, {
        method: 'GET'
      });
      return response;
    } catch (error) {
      console.error('Error fetching admin analytics:', error);
      throw error;
    }
  }
}

// Create and export singleton instance
const dashboardService = new DashboardService();
export default dashboardService;
